import React from "react";
import {
	List,
	Datagrid,
	TextField,
	Filter,
	SelectInput,
	Pagination,
	Button,
	TextInput,
} from "react-admin";
import { Clear } from '@material-ui/icons';

const CommissionPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />

const CommissionFilter = (props) => (
	<Filter {...props}>
		<TextInput source="email" label="Email" alwaysOn />
		<TextInput source="discount_code" label="Discount Code" alwaysOn />
		<SelectInput source="status" label="Status" choices={[
			{ id: 'Waiting for claim', name: 'Waiting for claim' },
			{ id: 'Claiming', name: 'Claiming' },
			{ id: 'Claimed', name: 'Claimed' },
		]} alwaysOn />
		 <Button
			label="Clear Filters"
			onClick={() => {
				// 清除所有过滤器
				props.setFilters({}, []);
			}}
			alwaysOn
		  >
			<Clear />
          </Button>
	</Filter>
);

const CommissionList = ({ permissions, ...props }) => (
	<List {...props} pagination={<CommissionPagination />} filters={<CommissionFilter />} bulkActionButtons={false} exporter={false} title={'Commissions'}>
		<Datagrid rowClick={false}>
			<TextField source="user.name" label="User Name" />
			<TextField source="user.email" label="User Email" />
			<TextField source="related_type" title="Related Type" />
			<TextField source="related_id" label="Related ID" />
			<TextField source="commission" label="Commission" />
			<TextField source="commission_currency" label="Currency" />
			<TextField source="discount_code" label="Discount Code" />
			<TextField source="status" label="Status" />
			<TextField source="created_at" label="Created Date" />
		</Datagrid>
	</List>
);

export default CommissionList;
